import React, { useState } from "react";
import MPHomeFirstBlock from "./BarberMainPageComps/MPHomeFirstBlock";
import MPHomeShowImages from "./BarberMainPageComps/MPHomeShowImages";
import MPHomeBookApp from "./BarberMainPageComps/MPHomeBookApp";
import MPHomeModalMakeApp from "./BarberMainPageComps/MPHomeModalMakeApp";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

export default function MPHome() {
  const { t, i18n } = useTranslation();

  const {
    OpenDrawer,
    setOpenDrawer,
    setAllApps,
    Loading,
    setLoading,
    setChoosedDate,
    setChoosedApps,
    setAllData,
    setUser,
    User,
    setAppContextLoading,
    AppContextLoading,
    OtherBarbers,
    setOtherBarbers,
    refreshDataCallback,
    setValue,
    value,
    AllowUsersBookApp,
    setAllowUsersBookApp,
    Lang,
    setLang,
  } = useAppContext();
  const lang = JSON.parse(localStorage.getItem("lang"));
  const [Choosing, setChoosing] = useState(lang);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Decorative background elements */}
      <div
        style={{
          position: "fixed",
          top: "-10%",
          right: "-5%",
          width: "40%",
          height: "40%",
          background:
            "radial-gradient(circle, rgba(102,126,234,0.08) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "fixed",
          bottom: "10%",
          left: "-5%",
          width: "35%",
          height: "35%",
          background:
            "radial-gradient(circle, rgba(118,75,162,0.06) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Main Content Container */}
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Hero Section with Barber Info */}
        <MPHomeFirstBlock />

        {/* Content Wrapper */}
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px",
            paddingBottom: "100px",
          }}
        >
          {/* Gallery Section */}
          <section
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
              marginTop: "-40px",
              position: "relative",
              zIndex: 2,
              overflow: "hidden",
              border: "1px solid rgba(0, 0, 0, 0.04)",
            }}
          >
            <MPHomeShowImages />
          </section>

          {/* Booking Section */}
          {AllowUsersBookApp === 1 ? (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "24px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                marginTop: "24px",
                padding: "32px 24px",
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.04)",
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  marginBottom: "24px",
                  paddingBottom: "16px",
                  borderBottom: "2px solid #f0f0f0",
                }}
              >
                <h2
                  style={{
                    fontSize: "22px",
                    fontWeight: "700",
                    color: "#1a1a1a",
                    margin: "0 0 8px 0",
                    letterSpacing: "-0.5px",
                  }}
                >
                  {t("BookYourAppointment")}
                </h2>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    margin: 0,
                    fontWeight: "400",
                  }}
                >
                  {t("ChoosePreferredDateTime")}
                </p>
              </div>

              <MPHomeBookApp />
            </section>
          ) : (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "24px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                marginTop: "24px",
                padding: "48px 32px",
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.04)",
                textAlign: "center",
              }}
            >
              {/* Icon */}
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  margin: "0 auto 24px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 8px 24px rgba(102, 126, 234, 0.25)",
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>

              {/* Title */}
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                  margin: "0 0 12px 0",
                  letterSpacing: "-0.5px",
                }}
              >
                {t("OnlineBookingComingSoon")}
              </h2>

              {/* Description */}
              <p
                style={{
                  fontSize: "16px",
                  color: "#6b7280",
                  margin: "0 0 32px 0",
                  lineHeight: "1.6",
                  maxWidth: "500px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {/* {t("BarberStopDescription")} */}
              </p>

              {/* Divider */}
              <div
                style={{
                  width: "60px",
                  height: "2px",
                  backgroundColor: "#e5e7eb",
                  margin: "0 auto 32px",
                  borderRadius: "2px",
                }}
              />

              {/* Contact Options */}
              <div style={{ marginBottom: "16px" }}>
                <p
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#374151",
                    margin: "0 0 20px 0",
                  }}
                >
                  {t("InTheMeantime")}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* SMS Button */}
                  <button
                    style={{
                      padding: "12px 24px",
                      borderRadius: "12px",
                      border: "2px solid #667eea",
                      backgroundColor: "#ffffff",
                      color: "#667eea",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#667eea";
                      e.currentTarget.style.color = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(102, 126, 234, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#667eea";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    {t("SMS")}
                  </button>

                  {/* Phone Button */}
                  <button
                    style={{
                      padding: "12px 24px",
                      borderRadius: "12px",
                      border: "2px solid #667eea",
                      backgroundColor: "#ffffff",
                      color: "#667eea",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#667eea";
                      e.currentTarget.style.color = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(102, 126, 234, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#667eea";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    {t("PhoneCall")}
                  </button>

                  {/* WhatsApp Button */}
                  <button
                    style={{
                      padding: "12px 24px",
                      borderRadius: "12px",
                      border: "2px solid #25D366",
                      backgroundColor: "#ffffff",
                      color: "#25D366",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#25D366";
                      e.currentTarget.style.color = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(37, 211, 102, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#25D366";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    {t("WhatsApp")}
                  </button>
                </div>
              </div>

              {/* Info Box */}
              {/* <div
                style={{
                  marginTop: "32px",
                  padding: "16px 20px",
                  backgroundColor: "#f0f4ff",
                  borderRadius: "12px",
                  border: "1px solid #d5dff8",
                  display: "inline-block",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    color: "#4b5563",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#667eea"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                  <span>
                    <strong>{t("Tip")}</strong> {t("MentionBarberStop")}
                  </span>
                </p>
              </div> */}
            </section>
          )}
        </div>

        {/* Premium Footer */}
        <footer
          style={{
            marginTop: "60px",
            padding: "40px 16px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            position: "relative",
            overflow: "hidden",
            paddingBottom: 120,
          }}
        >
          {/* Decorative elements */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
              pointerEvents: "none",
            }}
          />

          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "24px",
              }}
            >
              {/* Brand Section */}
              <div style={{ textAlign: "center" }}>
                <div>
                  <div
                    style={{
                      width: "100%",
                      height: "calc(50vh - 55px)",
                      padding: 20,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      <a
                        style={{
                          fontSize: 20,
                          fontWeight: "bold",
                        }}
                      >
                        {t("Chooselanguage")}
                      </a>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <p
                        style={{
                          margin: 5,
                          padding: 0,
                          fontSize: 18,
                          color: Lang === "he" ? "black" : "#a1a1aa",
                          cursor: "pointer",
                          fontWeight: Lang === "he" ? "bold" : "",
                        }}
                        onClick={() => {
                          setChoosing(lang);
                          setLang("he");
                          changeLanguage("he");
                          localStorage.setItem("lang", JSON.stringify("he"));
                        }}
                      >
                        עברית
                      </p>
                      <p
                        style={{
                          margin: 5,
                          padding: 0,
                          fontSize: 18,
                          cursor: "pointer",
                          color: Lang === "ar" ? "black" : "#a1a1aa",
                          fontWeight: Lang === "ar" ? "bold" : "",
                        }}
                        onClick={() => {
                          setChoosing(lang);
                          setLang("ar");
                          changeLanguage("ar");
                          localStorage.setItem("lang", JSON.stringify("ar"));
                        }}
                      >
                        العربية
                      </p>
                      <p
                        style={{
                          margin: 5,
                          padding: 0,
                          fontSize: 18,
                          cursor: "pointer",
                          color: Lang === "en" ? "black" : "#a1a1aa",
                          fontWeight: Lang === "en" ? "bold" : "",
                        }}
                        onClick={() => {
                          setChoosing(lang);
                          setLang("en");
                          changeLanguage("en");
                          localStorage.setItem("lang", JSON.stringify("en"));
                        }}
                      >
                        English
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#ffffff",
                    letterSpacing: "1px",
                    marginBottom: "8px",
                    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  NeholTorem
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: "400",
                  }}
                >
                  {t("ModernBookingSolutions")}
                </div>
              </div>

              {/* Divider */}
              <div
                style={{
                  width: "60px",
                  height: "2px",
                  backgroundColor: "rgba(255,255,255,0.3)",
                  borderRadius: "2px",
                }}
              />

              {/* Social Links (Optional) */}
              {/* <div style={{ display: "flex", gap: "16px" }}>
                {[
                  {
                    icon: (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                      </svg>
                    ),
                  },
                  {
                    icon: (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z" />
                      </svg>
                    ),
                  },
                  {
                    icon: (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" />
                      </svg>
                    ),
                  },
                ].map((social, index) => (
                  <button
                    key={index}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "12px",
                      backgroundColor: "rgba(255,255,255,0.15)",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      backdropFilter: "blur(10px)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(255,255,255,0.25)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(255,255,255,0.15)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {social.icon}
                  </button>
                ))}
              </div> */}

              {/* Copyright */}
              <div
                style={{
                  fontSize: "13px",
                  color: "rgba(255,255,255,0.8)",
                  textAlign: "center",
                }}
              >
                {t("Copyright")}
              </div>
            </div>
          </div>
        </footer>
      </div>

      <MPHomeModalMakeApp />
    </div>
  );
}
